import { z } from 'zod';
import { partnerCockpitLanguageSchema } from '../../partner-cockpit/user-management/auth.js';
import { subscriptionOrderSummarySchema } from './subscriptionOrderSummary.js';
export const SUBSCRIPTION_CHECKOUT_LINK_VALIDITY_IN_DAYS = 21;
export const subscriptionPaymentReturnSchema = z.enum(['success', 'cancelled']);
export const SubscriptionPaymentReturn = subscriptionPaymentReturnSchema.enum;
export const subscriptionCheckoutStateSchema = z.enum([
    'AwaitingConfirmation',
    // Card and TWINT only.
    'AwaitingPaymentDetails',
    'ConfirmedByPartner',
    'Superseded',
    'Expired',
    // Also covers a draft discarded in ops-tool, which hard-deletes the subscription.
    'Unavailable',
]);
export const SubscriptionCheckoutState = subscriptionCheckoutStateSchema.enum;
// The split is based on the information attached to the checkout screen and shown to the user.
export const subscriptionCheckoutStateWithOfferSchema = z.enum([
    subscriptionCheckoutStateSchema.enum.AwaitingConfirmation,
    subscriptionCheckoutStateSchema.enum.AwaitingPaymentDetails,
    subscriptionCheckoutStateSchema.enum.ConfirmedByPartner,
]);
export const subscriptionCheckoutStateWithoutOfferSchema = z.enum([
    subscriptionCheckoutStateSchema.enum.Superseded,
    subscriptionCheckoutStateSchema.enum.Expired,
    subscriptionCheckoutStateSchema.enum.Unavailable,
]);
// The order itself is the shared shape; everything added here belongs to the mailed link rather than to the sale.
export const subscriptionCheckoutOfferSchema = subscriptionOrderSummarySchema.extend({
    state: subscriptionCheckoutStateWithOfferSchema,
    partnerName: z.string(),
    termsVersion: z.string(),
    linkExpiresAt: z.iso.datetime(),
});
export const subscriptionCheckoutViewSchema = z.discriminatedUnion('state', [
    z.object({ state: subscriptionCheckoutStateWithoutOfferSchema }),
    subscriptionCheckoutOfferSchema,
]);
export const confirmSubscriptionCheckoutInputSchema = z.object({
    termsAccepted: z.literal(true),
    language: partnerCockpitLanguageSchema.optional(),
});
export const subscriptionCheckoutRedirectSchema = z.object({
    // Null on the invoice path, which collects nothing.
    redirectUrl: z.string().nullable(),
});
export const sendSubscriptionCheckoutLinkResultSchema = z.object({
    sentTo: z.email(),
    validUntil: z.iso.datetime(),
    supersededPreviousLink: z.boolean(),
});
